// src/components/common/TopNavbar.js
import React from "react";
import { Navbar, Container } from "react-bootstrap";
import "./DashboardCommon.css";

const TopNavbar = ({
  activeTab,
  currentUser,
  handleLogout,
  userRole = "admin",
}) => {
  // Mendapatkan judul berdasarkan peran pengguna dan tab aktif
  const getTitle = () => {
    if (userRole === "admin") {
      switch (activeTab) {
        case "overview":
          return "Selamat Datang";
        case "sectors":
          return "Manajemen Sektor";
        case "machines":
          return "Manajemen Mesin";
        case "users":
          return "Manajemen Pengguna";
        case "maintenance":
          return "Riwayat Maintenance";
        case "reports":
          return "Laporan";
        default:
          return "Selamat Datang";
      }
    } else if (userRole === "user") {
      switch (activeTab) {
        case "overview":
          return "Selamat datang";
        case "machines":
          return "Status Mesin";
        case "maintenance":
          return "Laporkan Masalah";
        case "history":
          return "Riwayat Maintenance";
        default:
          return "Selamat datang";
      }
    } else if (userRole === "maintenance") {
      switch (activeTab) {
        case "overview":
          return "Selamat datang";
        case "machines":
          return "Daftar Mesin";
        case "active":
          return "Perbaikan Aktif";
        case "history":
          return "Riwayat Maintenance";
        case "sectors":
          return "Daftar Sektor";
        default:
          return "Selamat datang";
      }
    }

    return "Dashboard";
  };

  return (
    <Navbar bg="white" expand="lg" className="mb-4 top-navbar">
      <Container fluid className="p-0">
        <Navbar.Brand>{getTitle()}</Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;
